import React from 'react';
import styled from 'styled-components';

import { Product } from 'src/utils/helpers/product';
import { ProductCarousel } from 'src/components/carousel-v2/types/product-carousel';

type CategoryRecommendationsCarouselProps = {
  products: Product[];
  loading: boolean;
  heading: string;
  subheading?: string;
  icon?: React.ReactNode;
};

export function CategoryRecommendationsCarousel({
  products,
  loading,
  heading,
  subheading,
  icon,
}: CategoryRecommendationsCarouselProps): JSX.Element | null {
  return (
    <BorderWrapper data-testid='category-recommendations-carousel'>
      <ProductCarousel
        products={products}
        isLoading={loading}
        title={heading}
        subTitle={subheading}
        icon={icon}
        mt='0'
      />
    </BorderWrapper>
  );
}

const BorderWrapper = styled.div`
  border: solid #e3e7e9;
  border-width: 1px 0;
  padding: 24px 0 4px;
`;
